module.exports = __webpack_public_path__ + "static/media/Investment.9f11c5ba.png";